import { SidebarInset, SidebarProvider, Toaster } from '@quadminds/mindkit';
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar/AppSidebar';
import Header from './Header/Header';
import { useFixedToParent } from '../../hooks/useFixedToParent';
import { ChatProvider } from '../../providers/Chat/Chat.provider';

export function Layout() {
    const sidebarInserRef = React.useRef<HTMLDivElement>(null);
    const headerRef = React.useRef<HTMLDivElement>(null);

    useFixedToParent(sidebarInserRef, headerRef);

    return (
        <SidebarProvider style={{ '--sidebar-width': '17rem' } as React.CSSProperties}>
            <ChatProvider>
                <AppSidebar />
                <SidebarInset ref={sidebarInserRef} className="pt-14">
                    <Header ref={headerRef} />
                    <Outlet />
                    <Toaster />
                </SidebarInset>
            </ChatProvider>
        </SidebarProvider>
    );
}

export default Layout;
